import postItem from "@/composables/postItem";
import putItem from "@/composables/putItem";

// update cluster
const updateClusterForEncounterDiagnosis = async (cluster, encounter) => {

    if (cluster && encounter) {
        let newCluster = cluster;
        // update encounter
        newCluster?.encounters?.forEach((x, y) => {

            if (x.id === encounter.id) {

                // update here
                newCluster.encounters[y].diagnosis = encounter?.diagnosis;

            }

        });

        return newCluster;
    } else {
        return null;
    }

}

// add
const addClaimSave = async (encounterId, newVal) => {
    // auth checker
    let authorization_status;
    let authorization_code;

    if (newVal.amt == 0) {
        authorization_status = "y";
        authorization_code = "Capitation";
    } else {
        authorization_status = "n";
        authorization_code = null;
    }

    const { res } = await postItem("claim", {
        encounter_id: encounterId,
        item: newVal.claim,
        sent_qty: newVal.qty,
        sent_price: newVal.amt,
        standard_price: newVal.standard,
        authorization: authorization_status,
        authorization_code: authorization_code,
        status: newVal.status,
    });

    if (res.value) {

        res.value.data.claim = res.value.data.item;
        res.value.data.qty = res.value.data.sent_qty;
        res.value.data.amt = res.value.data.sent_price;
        res.value.data.standard = res.value.data.standard_price;

        return res.value.data;

    } else {
        return null;
    }

};

// update
const updateSavedClaim = async (claimId, newVal) => {

    const { res } = await putItem("claim", claimId, {
        item: newVal.claim,
        sent_qty: newVal.qty,
        sent_price: newVal.amt
    });

    if (res.value) {

        res.value.data.claim = res.value.data.item;
        res.value.data.qty = res.value.data.sent_qty;
        res.value.data.amt = res.value.data.sent_price;

        return res.value.data;

    } else {
        return null;
    }

};

// delete
const deleteSavedClaim = async (claimId, newVal) => {

    const { res } = await putItem("claim", claimId, newVal);

    if (res.value) {
        return res.value.data;
    } else {
        return null;
    }

};

// update
const updateSavedEnrollee = async (encounterId, newVal) => {

    const { res } = await putItem("encounter", encounterId, newVal);

    if (res.value) {
        return res.value.data;
    } else {
        return null;
    }

};

// save diagnosis
const saveDiagnosis = async (encounterId, newVal) => {

    const { res } = await putItem("encounter", encounterId, newVal);

    if (res.value) {
        return res.value.data;
    } else {
        return null;
    }

};

// delete
const deleteSavedEnrollee = async (encounterId, newVal) => {

    const { res } = await putItem("encounter", encounterId, newVal);

    if (res.value) {
        return res.value.data;
    } else {
        return null;
    }

};

// sync
const syncSavedEnrollee = async (val, cluster) => {

    // defualt
    let newVal = {};

    // master confirmation
    if (val.encounter?.encounter_date_set) {

        // work on deletion
        if (!val.encounter.claims.length || val.encounter.status === "d") {

            newVal = await deleteSavedEnrollee(val.encounter.id, {
                status: "d",
                stores: val.encounter?.encounter_cluster_id,
                encounter_cluster_id: 0,
            });

            return newVal;

        } else {

            let hasChanged = false;

            cluster.encounters.forEach((x) => {
                if (x.editId === val.encounter.editId) {
                    if (val.encounter?.old_diagnosis ||
                        val.encounter?.old_encounter_date ||
                        val.encounter?.old_encounter_date_end) {
                        // set to true
                        hasChanged = true;
                    }
                }
            });

            if (hasChanged) {

                newVal = await updateSavedEnrollee(val.encounter.id, {
                    diagnosis: val.encounter?.diagnosis,
                    encounter_date: val.encounter?.encounter_date,
                    encounter_date_end: val.encounter?.encounter_date_end,
                }); // newVal is null if it fails

                return newVal;

            }

        }

    }

};

// dry
const dryDeleteEncounter = async (enrolleeId) => {

    // defualt
    let newVal = null;

    // operation
    newVal = await deleteSavedEnrollee(enrolleeId, {
        status: "d",
        stores: enrolleeId,
        encounter_cluster_id: 0,
    });

    // return
    return newVal;

};

// new encounter
// add
const addEncounterWithClaims = async (encounter) => {

    // clean up encounter
    // let keysToRemove = ["scheme", "claims", "created_at", "updated_at"];
    let keysToRemove = ["id", "scheme", "encounter", "plan", "created_at", "updated_at", "editId", "claims", "status"];
    let newEncounter = {
        ...Object.fromEntries(
            Object.entries(encounter).filter(
                ([key]) => !keysToRemove.includes(key)
            )
        ),
    };

    // Billing-cluster encounters stay open until their guarded q -> p submit.
    // Preserve the legacy direct-create status for callers without a cluster.
    newEncounter.status = encounter.encounter_cluster_id ? "q" : "p";

    // setup claims
    let newClaims = [];

    // auth checker
    let authorization_status;
    let authorization_code;

    // clean up claims
    encounter.claims.forEach((x) => {
        if (x.status === "a") {
            // map
            if (x.amt == 0) {
                authorization_status = "y";
                authorization_code = "Capitation";
            } else {
                authorization_status = "n";
                authorization_code = null;
            }

            // load
            newClaims.push({
                encounter_id: null,
                item: x.claim,
                sent_qty: x.qty,
                sent_price: x.amt,
                standard_price: x.standard,
                authorization: authorization_status,
                authorization_code: authorization_code,
                status: x.status,
            });
        }
    });

    // put all together
    let newVal = { encounter: newEncounter, claims: newClaims };

    // post item
    const { res } = await postItem("claim/enrollee/create/bulk", newVal);

    if (res.value) {
        // return
        return res.value.data;

    } else {

        // failure
        return null;

    }

};


export {
    addClaimSave,
    updateSavedClaim,
    updateClusterForEncounterDiagnosis,
    saveDiagnosis,
    deleteSavedClaim,
    syncSavedEnrollee,
    dryDeleteEncounter,
    addEncounterWithClaims,
}
